import React, { useEffect, useState } from 'react'
import { passReset } from '../Logic/index01';
import { useParams } from 'react-router-dom';
import { messageDisplay } from '../Auth/Util';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { CircularProgress } from 'react-loader-spinner';

const Forgot = () => {
const {k} = useParams();
const [password, setPassword] = useState("");
const [confirm, setConfirm] = useState("");
const [loading, setLoading] = useState(false);
const [showPassword, setShowPassword] = useState(false);
const strongPasswordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).+$/;





const  submitAll = async (password,confirm) => {
 if(password.length > 0 && confirm.length > 0){
    if(password === confirm){
        if(strongPasswordRegex.test(password) &&  password.length >= 8){
            setLoading(true);
            let wait = await passReset({obj:{pass:password,key:k}})
                if(wait){
                    setConfirm("")
                    setPassword("")
                    setLoading(false);
                    messageDisplay(wait, wait === "Account password updated." ? 0 : 1);
                }
           }else{
              messageDisplay("Password is weak, try a harder password",1);
           }
        }else{
          messageDisplay("Password not match",1);
        }
    }else{
        messageDisplay("Pls fill out all fields",1);
    }
}




 const togglePassword = () => {
    setShowPassword(!showPassword);
  };








  return <>
        <Header/>
        <div class="bg-white text-primary dark:text-gray-800 mt-12">
            <div class="min-h-screen flex flex-col relative overflow-x-hidden">

            <main class="flex-1 flex items-center justify-center p-4 md:p-8">
                <div class="w-full max-w-[480px] flex flex-col">

                    <div class="bg-background-light/95 rounded-xl shadow-sm border border-gray-100 mt-16 p-6 md:p-8">
                        <div class="mb-8">
                        <h1 class="text-slate-700 text-[18px] md:text-[32px] font-bold leading-tight mb-3">Reset your password</h1>
                    </div>

                    <div class="flex flex-col gap-6">
                      <div class="flex flex-col gap-2">
                        <label class="text-slate-500 text-sm font-medium leading-normal">New Password</label>
                        <div class="relative flex items-center">
                        <input  class="w-full rounded-lg border border-gray-200  bg-white  h-12 px-4 text-base text-primary  placeholder:text-gray-400" placeholder="Enter new password"  onChange={(e) => setPassword(e.target.value)}   value={password}   type={showPassword ? 'text' : 'password'}  />
                            <button onClick={togglePassword}  class="absolute inset-y-0 right-0 flex justify-center items-center p-3 text-brand-secondary" type="button">
                                    {!showPassword ? <span class="material-symbols-outlined cursor-pointer self-center">visibility</span>:  <span class="material-symbols-outlined cursor-pointer">visibility_off</span>}
                            </button>
                         </div>
                        </div>

                        <div class="flex flex-col gap-2">
                        <label class="text-slate-500 text-sm font-medium leading-normal" >Confirm New Password</label>
                        <div class="relative flex items-center">
                        <input class=" w-full rounded-lg border border-gray-200  bg-white  h-12 px-4 text-base text-primary" placeholder="Re-enter password"  onChange={(e) => setConfirm(e.target.value)}  value={confirm}  type={showPassword ? 'text' : 'password'} />
                           <button onClick={togglePassword}  class="absolute inset-y-0 right-0 flex justify-center items-center p-3 text-brand-secondary" type="button">
                                    {!showPassword ? <span class="material-symbols-outlined cursor-pointer self-center">visibility</span>:  <span class="material-symbols-outlined cursor-pointer">visibility_off</span>}
                            </button>
                        </div>
                        </div>

                        <div class="bg-gray-50 dark:bg-white/5 rounded-lg p-4 border border-gray-100 dark:border-white/5">
                            <p class="text-xs font-semibold text-slate-500 uppercase mb-3">Password Requirements</p>
                            <div class="space-y-3">
                            <label class="flex items-center gap-3 cursor-pointer group">
                            <span class="text-slate-500 text-sm font-normal">At least 8 characters</span>
                            </label>
                            <label class="flex items-center gap-3 cursor-pointer group">
                            <span class="text-slate-500 text-sm font-normal">Contains a number</span>
                            </label>
                            <label class="flex items-center gap-3 cursor-pointer group">
                            <span class="text-slate-500 text-sm font-normal">Contains a symbol</span>
                            </label>
                            </div>
                        </div>

                        <button  onClick={(e) => submitAll(password,confirm)} class="w-full bg-blue-600 hover:bg-black/90 hover:bg-slate-200  text-white font-bold h-12 rounded-lg flex items-center justify-center gap-2 mt-2 shadow-sm hover:shadow-md">
                         {loading ? <CircularProgress width={20} height={20} color='#ffffff' /> :
                            <div className='flex justify-center'>
                                <span>Reset Password</span>
                                <span class="material-symbols-outlined text-[18px] self-center">arrow_forward</span>
                            </div>
                          }
                        </button>
                    </div>
                </div>
             </div>
            </main>
        </div>
     </div>  
    <Footer/>
  </>
}

export default Forgot
